import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFound from "./layouts/NotFound";
import LicenseDetails from "./layouts/LicenseDetails";
import Timeout from "./layouts/Timeout";
import Home from "./layouts/Home";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/license-portal" element={<LicenseDetails />} />
        <Route path="/timeout" element={<Timeout />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
